<template>
    <div>

        <div class="row">
            <div class="col-xl-4 offset-xl-4 col-lg-4 col-lg-5 col-md-6 offset-md-3 col-12">

                <div class="card card-box mb-3 ninja-shadow ">

                    <div class="card-body" id="prints">

                        <b-row class="text-center mb-5 mt-5">

                            <b-col>

                                <img v-if="klinik.foto_klinik == null" class="img-logo" src="/img/new_logo.png"
                                    alt="image body" />

                                <img v-else :src="klinik.foto_klinik" class="img-logo" alt="image body" />

                                <br /> {{ klinik.nama_klinik ? labelStartCase(klinik.nama_klinik) : '-' }} <br>

                                <template v-if="this.isDpm">

                                    No. SIP {{ klinik.nomor_ijin || '-' }} <br>
                                </template>
                                <template v-else>
                                    No. Izin {{ klinik.nomor_ijin || '-' }} <br>
                                </template>
                            </b-col>
                        </b-row>
                        <div class="d-flex flex-column">
                            <b-row class="mt-3 mb-1">
                                <b-col cols="12">
                                    <b-row class="mb-1">
                                        <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">No.
                                            Invoice</b-col>
                                        <b-col cols="1" class="pl-0">:</b-col>
                                        <b-col cols="6" class="pl-0">{{ dataStruk.no_invoice || '-' }}</b-col>
                                    </b-row>
                                    <b-row class="mb-1">
                                        <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">No. RM</b-col>
                                        <b-col cols="1" class="pl-0">:</b-col>
                                        <b-col cols="6" class="pl-0">{{ dataStruk.nomor_rekam_medis || '-' }}</b-col>
                                    </b-row>
                                    <b-row class="mb-1">
                                        <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">Nama
                                            Pasien</b-col>
                                        <b-col cols="1" class="pl-0">:</b-col>
                                        <b-col cols="6" class="pl-0">{{ dataStruk.nama ? labelStartCase(dataStruk.nama)
                                            :
                                            '-' }}
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-1">
                                        <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">Poliklinik</b-col>
                                        <b-col cols="1" class="pl-0">:</b-col>
                                        <b-col cols="6" class="pl-0">{{ dataStruk.poliklinik ? `${dataStruk.poliklinik}
                                            (${dataStruk.kategori})` :
                                            '-'
                                            }}</b-col>
                                    </b-row>
                                    <b-row class="mb-1">
                                        <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">Tenaga Medis
                                            1</b-col>
                                        <b-col cols="1" class="pl-0">:</b-col>
                                        <b-col cols="6" class="pl-0">{{ dataStruk.dokter ?
                                            labelStartCase(dataStruk.dokter)
                                            :
                                            '-'
                                            }}</b-col>
                                    </b-row>
                                    <b-row class="mb-1">
                                        <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">Tenaga Medis
                                            2</b-col>
                                        <b-col cols="1" class="pl-0">:</b-col>
                                        <b-col cols="6" class="pl-0">{{ dataStruk.perawat_name ?
                                            labelStartCase(dataStruk.perawat_name) : '-'
                                            }}
                                        </b-col>
                                    </b-row>
                                    <b-row class="mb-1">
                                        <b-col cols="5" class="font-weight-bold pr-0 color-gray-text">Metode
                                            Pembayaran</b-col>
                                        <b-col cols="1" class="pl-0">:</b-col>
                                        <b-col cols="6" class="pl-0" v-if="dataStruk.status == 'LUNAS'">{{
                                            labelMetodePembayaran(dataStruk)
                                            }}</b-col>
                                        <b-col cols="6" class="pl-0" v-else> -</b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <hr class="bordering" />
                            <b-row class="f12 mb-2">
                                <b-col cols="12" class="font-weight-bold">Layanan/Obat/Habis Pakai</b-col>
                            </b-row>
                            <b-row class="f12">
                                <b-col cols="1" class="pr-0 w1">No</b-col>
                                <b-col cols="5" class="pr-0 w5">Qty x Harga Layanan</b-col>
                                <b-col cols="6" class="text-right pl-0 w6">Sub Total (Rp)</b-col>
                            </b-row>
                            <hr class="bordering" />
                            <div v-if="details != null">
                                <div class="category-bpjs" v-if="tindakanBpjs.length > 0 || obatBpjs.length > 0">
                                    <h6 class="font-weight-bold mb-4 color-gray-text">Ditanggung BPJS</h6>
                                    <hr class="bordering" />
                                    <div v-for="(item, index) in tindakanBpjs" :key="item.id">
                                        <b-row class="f12">
                                            <b-col cols="12" class="font-weight-bold d-flex" style="display:flex;">
                                                <div class="w-30">
                                                    {{ index + 1 }}.
                                                </div>
                                                <div>
                                                    {{ item.nama_layanan }}
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="f12">
                                            <b-col cols="12 d-flex">
                                                <div class="w-30"></div>
                                                <div>
                                                    {{ item.quantity }} x Rp0,-
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="f12">
                                            <b-col cols="1" class="font-weight-bold pr-0"></b-col>
                                            <b-col cols="5">
                                            </b-col>
                                            <b-col cols="6" class="text-right send-top">Rp0,-</b-col>
                                        </b-row>
                                    </div>
                                    <div v-for="(item, index) in obatBpjs" :key="item.id">
                                        <b-row class="f12">
                                            <b-col cols="12" class="font-weight-bold d-flex" style="display:flex;">
                                                <div class="w-30">
                                                    {{ tindakanBpjs.length + index + 1 }}.
                                                </div>
                                                <div>
                                                    {{ item.nama_layanan }}
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="f12">
                                            <b-col cols="12 d-flex">
                                                <div class="w-30"></div>
                                                <div>
                                                    {{ item.quantity }} x Rp0,-
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="f12">
                                            <b-col cols="1" class="font-weight-bold pr-0"></b-col>
                                            <b-col cols="5">
                                            </b-col>
                                            <b-col cols="6" class="text-right send-top">Rp0,-</b-col>
                                        </b-row>
                                    </div>
                                </div>
                                <div class="category-mandiri">
                                    <template>
                                        <div v-if="isBpjs">

                                            <h6 class="font-weight-bold mb-4 color-gray-text">Tidak Ditanggung BPJS</h6>

                                            <hr class="bordering" />

                                        </div>
                                    </template>
                                    <div v-for="(item, index) in layananNormal" :key="item.id">
                                        <b-row class="f12">
                                            <b-col cols="12" class="font-weight-bold d-flex" style="display:flex;">
                                                <div class="w-30">
                                                    {{ tindakanBpjs.length + obatBpjs.length + index + 1 }}.
                                                </div>
                                                <div>
                                                    {{ item.nama_layanan }}
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="f12">
                                            <b-col cols="12 d-flex">
                                                <div class="w-30"></div>
                                                <div>
                                                    {{ item.quantity }} x
                                                    Rp{{
                                                        parseFloat(item.tarif).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                                    "$1.") }},-
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="f12">
                                            <b-col cols="1" class="font-weight-bold pr-0"></b-col>
                                            <b-col cols="5">
                                                <span v-if="item.jenis_potongan == 'RUPIAH'">Diskon Rp{{
                                                    parseFloat(item.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                                        "$1.")
                                                    }},-</span>
                                                <span v-if="item.jenis_potongan == 'PERSENTASE'">Diskon {{
                                                    parseFloat(item.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                                        "$1.")
                                                    }}%</span>
                                            </b-col>
                                            <b-col cols="6" class="text-right send-top">Rp{{
                                                parseFloat(item.subtotal_tarif_net).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                                    "$1.")
                                                }},-</b-col>
                                        </b-row>
                                    </div>
                                    <div v-if="layananNormal.length == 0">
                                        <b-row>
                                            <b-col class="font-weight-bold">
                                                <h4>-</h4>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <div v-else>
                                        <hr class="bordering mt-5" />
                                    </div>
                                </div>
                            </div>
                            <div v-if="dataStruk != null">
                                <b-row class="f12 mb-3">
                                    <b-col cols="6" class="pr-0 p-col-6">{{ labelTotal(dataStruk) }}</b-col>
                                    <b-col cols="6" class="text-right p-col-6">{{ calculateTotal(dataStruk) }}</b-col>
                                </b-row>
                                <b-row class="f12 mb-3">
                                    <b-col cols="6" class="pr-0 p-col-6">DISKON</b-col>
                                    <b-col cols="6" class="text-right p-col-6">
                                        <span v-if="dataStruk.jenis_potongan == 'RUPIAH'">Rp{{
                                            parseFloat(dataStruk.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                                "$1.")
                                            }},-</span>
                                        <span v-else-if="dataStruk.jenis_potongan == 'PERSENTASE'">{{
                                            parseFloat(dataStruk.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                                "$1.")
                                            }}%</span>
                                        <span v-else>Rp0,-</span>
                                    </b-col>
                                </b-row>
                                <b-row class="f12 mb-5">
                                    <b-col cols="6" class="font-weight-bold pr-0 p-col-6">TOTAL NETT</b-col>
                                    <b-col cols="6" class="text-right p-col-6">{{
                                        `Rp${parseFloat(dataStruk.total_net).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                            "$1.")},-`
                                        }}</b-col>
                                </b-row>
                            </div>
                            <b-row class="f12 mb-5">
                                <b-col cols="7" offset="5" class="text-right">{{ tanggalCetak }}</b-col>
                            </b-row>
                            <b-row class="f12 mb-5">
                                <b-col cols="5" offset="7" class="text-center">{{ labelStartCase(dataStruk.kasir)
                                    }}</b-col>
                            </b-row>
                            <b-row class="f12 mt-3">
                                <b-col cols="12">
                                    Created by : {{ labelStartCase(dataStruk.kasir) }} <br />
                                    Created time : {{ dataStruk.created_time }} <br />
                                    Admission time : {{ dataStruk.admission_time }} <br />
                                </b-col>
                            </b-row>
                            <b-row class="f12 mt-3">
                                <b-col cols="12" class="text-center">
                                    <small class="font-weight-bold">Powered by:</small> <br>
                                </b-col>
                                <b-col cols="12 text-center">
                                    <img :src="require('@/assets/izidok.png')" class="print-logo" width="100"
                                        alt="izidok">
                                    <br />
                                    <br />
                                    <br />
                                    ******************
                                    <br />
                                    Semoga Lekas Sembuh dan Sehat Selalu
                                </b-col>
                            </b-row>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div style="width: 464px;" id="print" class="fw-struk d-none">
            <b-row class="text-center">
                <b-col>
                    <img v-if="klinik.foto_klinik == null" class="img-logo center" src="/img/new_logo.png"
                        alt="image body" style="margin-left: 39%;" />
                    <img v-if="klinik.foto_klinik != null" class="img-logo-custom" :src="logoKlinik" alt="image body" />
                    <br />
                    <p class="f25">
                        {{ klinik.nama_klinik ? labelStartCase(klinik.nama_klinik) : '-' }} <br>
                    </p>
                    <p class="fw-struk f25">
                        <template v-if="this.isDpm">
                            No. SIP {{ klinik.nomor_ijin || '-' }} <br>
                        </template>
                        <template v-else>
                            No. Izin {{ klinik.nomor_ijin || '-' }} <br>
                        </template>
                    </p>
                </b-col>
            </b-row>
            <div class="d-flex flex-column f25" style="color: #000;">
                <b-row class="mt-3 mb-1">
                    <b-col cols="12 fw-struk">
                        <b-row class="mb-1">
                            <b-col cols="5" class="fw-struk pr-0 color-gray-text-print">No.
                                Invoice</b-col>
                            <b-col cols="1" class="pl-0">:</b-col>
                            <b-col cols="6" class="pl-0">{{ dataStruk.no_invoice || '-' }}</b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col cols="5" class=" fw-struk pr-0 color-gray-text-print">No. RM</b-col>
                            <b-col cols="1" class="pl-0">:</b-col>
                            <b-col cols="6" class="pl-0">{{ dataStruk.nomor_rekam_medis || '-' }}</b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col cols="5" class=" fw-struk pr-0 color-gray-text-print">Nama
                                Pasien</b-col>
                            <b-col cols="1" class="pl-0">:</b-col>
                            <b-col cols="6" class="pl-0">{{ dataStruk.nama ? labelStartCase(dataStruk.nama) :
                                '-' }}
                            </b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col cols="5" class=" fw-struk pr-0 color-gray-text-print">Poliklinik</b-col>
                            <b-col cols="1" class="pl-0">:</b-col>
                            <b-col cols="6" class="pl-0">{{ dataStruk.poliklinik ? `${dataStruk.poliklinik}
                                (${dataStruk.kategori})` :
                                '-'
                            }}</b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col cols="5" class=" fw-struk pr-0 color-gray-text-print">Tenaga Medis
                                1</b-col>
                            <b-col cols="1" class="pl-0">:</b-col>
                            <b-col cols="6" class="pl-0">{{ dataStruk.dokter ? labelStartCase(dataStruk.dokter)
                                :
                                '-'
                            }}</b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col cols="5" class=" fw-struk pr-0 color-gray-text-print">Tenaga Medis
                                2</b-col>
                            <b-col cols="1" class="pl-0">:</b-col>
                            <b-col cols="6" class="pl-0">{{ dataStruk.perawat_name ?
                                labelStartCase(dataStruk.perawat_name) : '-'
                                }}
                            </b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col cols="5" class=" fw-struk pr-0 color-gray-text-print">Metode
                                Pembayaran</b-col>
                            <b-col cols="1" class="pl-0">:</b-col>
                            <b-col cols="6" class="pl-0" v-if="dataStruk.status == 'LUNAS'">{{
                                labelMetodePembayaran(dataStruk)
                                }}</b-col>
                            <b-col cols="6" class="pl-0" v-else> -</b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="bordering" />
                <b-row class="f25 mb-2">
                    <b-col cols="12" class=" fw-struk">Layanan/Obat/Habis Pakai</b-col>
                </b-row>
                <b-row class="f25 fw-struk">
                    <b-col cols="1" class="pr-0 w1">No</b-col>
                    <b-col cols="5" class="pr-0 w5">Qty x Harga Layanan</b-col>
                    <b-col cols="6" class="text-right pl-0 w6">Sub Total (Rp)</b-col>
                </b-row>
                <hr class="bordering" />
                <div v-if="details != null" class="fw-struk">
                    <div class="category-bpjs fw-struk" v-if="tindakanBpjs.length > 0 || obatBpjs.length > 0">
                        <h6 class=" fw-struk mb-4 color-gray-text">Ditanggung BPJS</h6>
                        <hr class="bordering" />
                        <div v-for="(item, index) in tindakanBpjs" :key="item.id">
                            <b-row class="f25">
                                <b-col cols="12" class=" fw-struk d-flex" style="display:flex;">
                                    <div class="w-30">
                                        {{ index + 1 }}.
                                    </div>
                                    <div>
                                        {{ item.nama_layanan }}
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="f25">
                                <b-col cols="12 d-flex">
                                    <div class="w-30"></div>
                                    <div>
                                        {{ item.quantity }} x Rp0,-
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="f25">
                                <b-col cols="1" class=" fw-struk pr-0"></b-col>
                                <b-col cols="5">
                                </b-col>
                                <b-col cols="6" class="text-right send-top">Rp0,-</b-col>
                            </b-row>
                        </div>
                        <div v-for="(item, index) in obatBpjs" :key="item.id">
                            <b-row class="f25">
                                <b-col cols="12" class="fw-struk d-flex" style="display:flex;">
                                    <div class="w-30">
                                        {{ tindakanBpjs.length + index + 1 }}.
                                    </div>
                                    <div>
                                        {{ item.nama_layanan }}
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="f25">
                                <b-col cols="12 d-flex">
                                    <div class="w-30"></div>
                                    <div>
                                        {{ item.quantity }} x Rp0,-
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="f25">
                                <b-col cols="1" class=" fw-struk pr-0"></b-col>
                                <b-col cols="5">
                                </b-col>
                                <b-col cols="6" class="text-right send-top">Rp0,-</b-col>
                            </b-row>
                        </div>
                    </div>
                    <div class="category-mandiri fw-struk">
                        <template>
                            <div v-if="isBpjs">

                                <h6 class=" fw-struk mb-4 color-gray-text-print">Tidak Ditanggung BPJS

                                </h6>

                                <hr class="bordering" />

                            </div>
                        </template>
                        <div v-for="(item, index) in layananNormal" :key="item.id">
                            <b-row class="f25">
                                <b-col cols="12" class=" fw-struk d-flex" style="display:flex;">
                                    <div class="w-30">
                                        {{ tindakanBpjs.length + obatBpjs.length + index + 1 }}.
                                    </div>
                                    <div>
                                        {{ item.nama_layanan }}
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="f25">
                                <b-col cols="12 d-flex">
                                    <div class="w-30"></div>
                                    <div>
                                        {{ item.quantity }} x
                                        Rp{{ parseFloat(item.tarif).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                            "$1.") }},-
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="f25">
                                <b-col cols="1" class=" fw-struk pr-0"></b-col>
                                <b-col cols="5">
                                    <span v-if="item.jenis_potongan == 'RUPIAH'">Diskon Rp{{
                                        parseFloat(item.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                            "$1.")
                                    }},-</span>
                                    <span v-if="item.jenis_potongan == 'PERSENTASE'">Diskon {{
                                        parseFloat(item.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                            "$1.")
                                    }}%</span>
                                </b-col>
                                <b-col cols="6" class="text-right send-top">Rp{{
                                    parseFloat(item.subtotal_tarif_net).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                        "$1.")
                                }},-</b-col>
                            </b-row>
                        </div>
                        <div v-if="layananNormal.length == 0">
                            <b-row>
                                <b-col class=" fw-struk">
                                    <h4>-</h4>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else>
                            <hr class="bordering mt-5" />
                        </div>
                    </div>
                </div>
                <div v-if="dataStruk != null" class="fw-struk">
                    <b-row class="f25 mb-3">
                        <b-col cols="6" class="pr-0 p-col-6">{{ labelTotal(dataStruk) }}</b-col>
                        <b-col cols="6" class="text-right p-col-6">{{ calculateTotal(dataStruk) }}</b-col>
                    </b-row>
                    <b-row class="f25 mb-3">
                        <b-col cols="6" class="pr-0 p-col-6">DISKON</b-col>
                        <b-col cols="6" class="text-right p-col-6">
                            <span v-if="dataStruk.jenis_potongan == 'RUPIAH'">Rp{{
                                parseFloat(dataStruk.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1.")
                            }},-</span>
                            <span v-else-if="dataStruk.jenis_potongan == 'PERSENTASE'">{{
                                parseFloat(dataStruk.potongan).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                    "$1.")
                            }}%</span>
                            <span v-else>Rp0,-</span>
                        </b-col>
                    </b-row>
                    <b-row class="f25 mb-5">
                        <b-col cols="6" class=" fw-struk pr-0 p-col-6">TOTAL NETT</b-col>
                        <b-col cols="6" class="text-right p-col-6">{{
                            `Rp${parseFloat(dataStruk.total_net).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                                "$1.")},-`
                        }}</b-col>
                    </b-row>
                </div>
                <b-row class="f25 mb-5 fw-struk">
                    <b-col cols="7" offset="5" class="text-right">{{ tanggalCetak }}</b-col>
                </b-row>
                <b-row class="f25 mb-5 fw-struk">
                    <b-col cols="5" offset="7" class="text-center">{{ labelStartCase(dataStruk.kasir) }}</b-col>
                </b-row>
                <b-row class="f25 mt-3 fw-struk">
                    <b-col cols="12">
                        Created by : {{ labelStartCase(dataStruk.kasir) }} <br />
                        Created time : {{ dataStruk.created_time }} <br />
                        Admission time : {{ dataStruk.admission_time }} <br />
                    </b-col>
                </b-row>
                <b-row class="f25 mt-3 fw-struk">
                    <b-col cols="12" class="text-center">
                        <small class=" fw-struk">Powered by:</small> <br>
                    </b-col>
                    <b-col cols="12 text-center">
                        <img :src="require('@/assets/izidok.png')" class="print-logo" width="100" alt="izidok">
                        <br />
                        <br />
                        <br />
                        ******************
                        <br />
                        Semoga Lekas Sembuh dan Sehat Selalu
                    </b-col>
                </b-row>
            </div>
        </div>

    </div>
</template>

<script>
import startCase from "lodash/startCase"
import axios from 'axios'

export default {
    data() {
        return {
            isBpjs: false,
            layananNormal: [],
            obatBpjs: [],
            tindakanBpjs: [],
            logoKlinik: null
        }
    },
    props: ['dataStruk', 'details', 'klinik', 'isDpm'],
    watch: {
        dataStruk: {
            deep: true,
            handler(val) {
                this.isBpjs = val.kategori == 'BPJS' ? true : false;
                this.getLayananType();
            }
        },
        klinik: {
            deep: true,
            async handler(val) {
                if (val.foto_klinik) {
                    try {
                        const hasilBase64 = await this.urlToBase64(this.klinik.foto_klinik);
                        this.logoKlinik = hasilBase64;
                    } catch (err) {
                    }
                }
            }
        }
    },
    async mounted() {
        if (this.klinik.foto_klinik) {
            try {
                const hasilBase64 = await this.urlToBase64(this.klinik.foto_klinik);
                this.logoKlinik = hasilBase64;
            } catch (err) {
            }
        }
    },
    methods: {
        async urlToBase64(imgUrl) {
            const res = await this.$axios.post('conver-image-to-base64', { file: imgUrl });
            if (res.data.status) {
                return res.data.data
            }

        },
        getLayananType() {
            this.layananNormal = []
            this.obatBpjs = []
            this.tindakanBpjs = []
            let data = this.details;

            data.forEach((item) => {
                // set default to 0 if null attribute
                item.subtotal_tarif = item.subtotal_tarif || 0,
                    item.subtotal_tarif_net = item.subtotal_tarif_net || 0,
                    item.tarif = item.tarif || 0

                if (item.from_bpjs == 0) {
                    this.layananNormal.push(item);
                } else if (item.from_bpjs == 1 && item.bpjs_sk_type == 0) {
                    this.tindakanBpjs.push(item);
                } else if (item.from_bpjs == 1 && item.bpjs_sk_type == 1) {
                    this.obatBpjs.push(item);
                }
            })

            this.layananNormal = this.layananNormal;
        },
        fields() {
            return [
                { key: 'layanan', label: "Layanan/Obat/Bahan Habis Pakai" },
                { key: "quantity", label: "QTY" },
                { key: "tarif", label: "Harga" },
                { key: "jenis_potongan", label: "Diskon" },
                { key: "potongan", label: "Nilai Diskon" },
                { key: "subtotal_tarif_net", label: "Sub Total (Rp)" },
            ]
        },
        cekNilaiDiskon(val) {
            let cek = true
            if (val == 'Total' || val == 'Total Dibayar Pasien' || val == 'Diskon Total' || val == 'Total Nett') cek = false
            return cek
        },
        labelStartCase(val) {
            return startCase(val)
        },
        calculateTotal(data) {
            let total = 0;
            if (data && data.detail && data.detail.length > 0) {
                if (data.kategori == 'BPJS') {
                    data.detail.forEach((d) => {
                        if (d.from_bpjs == 0 && !d.is_resep) {
                            total += d.subtotal_tarif_net;
                        }
                    });
                } else {
                    data.detail.forEach((d) => {
                        if (!d.is_resep) total += d.subtotal_tarif_net;
                    });
                }
            }
            return `Rp${parseFloat(total).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")},-`;
        },
        labelTotal(data) {
            let label = 'TOTAL';
            if (data.kategori == 'BPJS') {
                if (data.klinik && data.klinik.bpjs_cons_id) label = 'TOTAL DIBAYAR PASIEN';
            }
            return label;
        },
        labelMetodePembayaran(data) {
            if (this.isBpjs) {
                const checkAllBPJS = data.detail.filter((d) => d.from_bpjs == 0);
                if (checkAllBPJS.length > 0) {
                    if (data.nama_bank && data.nama_rekening) {
                        return `${data.jenis_pembayaran} (${data.nama_bank.toUpperCase()}-${data.nama_rekening})`;
                    } else {
                        return data.jenis_pembayaran;
                    }
                } else {
                    return 'BPJS';
                }
            } else {
                if (data.nama_bank && data.nama_rekening) {
                    return `${data.jenis_pembayaran} (${data.nama_bank}-${data.nama_rekening})`;
                } else {
                    return data.jenis_pembayaran;
                }
            }
        }
    },
    computed: {
        tanggalCetak() {
            let tglCetak = "";
            if (this.dataStruk.date_now) {
                let datenow = this.dataStruk.date_now.split(",");
                let kota = this.dataStruk.klinik.kota_detail.nama;
                kota = kota.includes("Kota") ? kota.replace("Kota", "") : kota.replace("Kabupaten", "");
                tglCetak = kota + "," + datenow[1];
            }
            return tglCetak;
        }
    },
}
</script>
<style lang="scss" scoped>
.color-gray-text {
    color: #848484
}

.color-gray-text-print {
    color: #000
}

.pembayaran-status {
    position: absolute;
    top: 62%;
    left: 30%;
}

.struk-pembayaran {
    zoom: 90%;
}

.img-logo {
    height: 100px;
    border-radius: 10px;
}

.center-set {
    // left: 25%;
}

.bordering {
    border: 1px solid #b1acac;
    width: 100%;
}

.f12 {
    font-size: 12px;
}

.send-top {
    top: -18px;
}

.w-30 {
    min-width: 30px;
    max-width: 30px;
}
</style>

<style lang="scss">
.table {
    &.table-pembayaran-struk {
        thead {
            th {
                background-color: #4896e8 !important;
                color: #ffffff !important;
                text-transform: none;
            }
        }
    }
}

.modal-backdrop {
    opacity: 0.5 !important;
}

@page {
    size: auto;
    margin: 0;
}

body {
    letter-spacing: 0.01px;
    background: #ffffff !important;
    color: #000000 !important;
}

@media print {
    body {
        background-color: transparent !important;
        margin-left: 1px;
    }

    div.app-main {
        background-color: transparent !important;
    }

    div.app-content {
        background-color: transparent !important;
    }

    div.app-header {
        display: none !important;
    }

    div.app-sidebar {
        display: none !important;
    }

    div.app-footer {
        display: none !important;
    }

    div.app-content {
        margin: 0;
        padding-top: 1rem !important;
    }

    .pembayaran-status {
        position: absolute;
        top: 52% !important;
        left: 20% !important;
    }

    .table {
        &.table-pembayaran-struk {
            thead {
                th {
                    background-color: #4896e8 !important;
                    -webkit-print-color-adjust: exact;
                }
            }
        }
    }

    .center-set {
        left: -50px !important;
    }

    .card-box {
        border-width: 0 !important;
    }

    .center-set.col {
        padding: 0 !important;
    }

    .card {
        box-shadow: none !important;
    }

    * {
        font-family: 'Courier New', Courier, monospace;
        font-size: 12px;
        line-height: 12px;
    }

    .img-logo {
        height: 100px;
        border-radius: 10px;
    }

    .f12 {
        font-size: 12px;
    }

    .pr-0 {
        padding-right: 0 !important;
    }

    .pl-0 {
        padding-left: 0 !important;
    }

    .w1 {
        -moz-box-flex: 0 !important;
        flex: 0 0 9% !important;
        max-width: 9% !important;
    }

    .w5 {
        -moz-box-flex: 0 !important;
        flex: 0 0 50% !important;
        max-width: 50% !important;
    }

    .w6 {
        -moz-box-flex: 0 !important;
        flex: 0 0 41% !important;
        max-width: 41% !important;
    }

    .w-30 {
        min-width: 0px;
        max-width: 0px;
    }
}

.f25 {
    font-size: 20px;
}

.center {
    text-align: center;
}

.fw-struk {
    font-weight: 600;
}

#print {
    font-family: 'Courier New', Courier, monospace;
    line-height: 25px;
}

.img-logo-custom {
    height: 150px;
    margin: auto;
}

.print-logo {
    margin: auto;
}
</style>
